module.exports = __webpack_public_path__ + "static/media/slider_1_en_md.7d9b341e.svg";